import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LayoutList, Trash2 } from "lucide-react";

export function CategoryTemplateMenu({ issueId, onApplied }) {
  const [templates, setTemplates] = useState([]);
  const load = () => api.get("/category-templates").then((r) => setTemplates(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const saveAs = async () => {
    const name = window.prompt("Name der Kategorie-Vorlage (z. B. „Standard-Ausgabe“):");
    if (!name?.trim()) return;
    try { await api.post("/category-templates", { name, issue_id: issueId }); toast.success("Vorlage gespeichert"); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  const apply = async (t) => {
    try {
      const { data } = await api.post(`/issues/${issueId}/apply-category-template`, { template_id: t.id });
      toast.success(`${data.added} Kategorie(n) hinzugefügt`); onApplied();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  const remove = async (t) => {
    if (!window.confirm(`Vorlage „${t.name}“ löschen?`)) return;
    await api.delete(`/category-templates/${t.id}`); load();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" data-testid="category-template-menu"><LayoutList size={15} className="mr-1.5" /> Kategorie-Vorlagen</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72">
        <DropdownMenuItem onSelect={saveAs} data-testid="category-template-save">Aktuelle Kategorien als Vorlage speichern</DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuLabel className="text-xs text-slate-500">Vorlage anwenden (fehlende Kategorien ergänzen)</DropdownMenuLabel>
        {templates.map((t) => (
          <DropdownMenuItem key={t.id} onSelect={() => apply(t)} className="flex justify-between gap-2" data-testid={`category-template-apply-${t.id}`}>
            <span className="truncate">{t.name} <span className="text-slate-400">({t.categories.length})</span></span>
            <button type="button" onClick={(e) => { e.stopPropagation(); e.preventDefault(); remove(t); }} className="text-slate-400 hover:text-red-500" data-testid={`category-template-delete-${t.id}`}><Trash2 size={13} /></button>
          </DropdownMenuItem>
        ))}
        {templates.length === 0 && <div className="px-2 py-1.5 text-xs text-slate-400">Noch keine Vorlagen</div>}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
